import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0274966b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pa-3 pa-sm-2 pa-md-2 components--sell-form",
  ref: "formDiv"
}
const _hoisted_2 = { class: "mb-6 mt-6" }
const _hoisted_3 = { class: "d-flex justify-space-between mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-4 textDark--text" }, " How much do you want to sell? ", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-mew"
}
const _hoisted_6 = { class: "d-flex mt-2" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "mt-2 mx-4" }
const _hoisted_9 = { class: "mb-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-4 textDark--text mb-3" }, "You will get", -1))
const _hoisted_11 = { class: "d-flex mt-2" }
const _hoisted_12 = { class: "currency-container" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "d-flex align-center" }
const _hoisted_16 = { class: "currency-container padding--2 mr-1 ml-3" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "text-capitalize ml-2 my-2 d-flex flex-column" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-center justify-space-between mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-4 mr-2" }, " What wallet are you sending your crypto from? ")
], -1))
const _hoisted_20 = { class: "text-gray mt-3 mb-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "text-bolder"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray" }, "Fees:", -1))
const _hoisted_25 = {
  class: "text-gray",
  style: {"float":"right"}
}
const _hoisted_26 = {
  key: 1,
  class: "text-bolder text-error mew-heading-4 text-center"
}
const _hoisted_27 = { class: "text-gray" }
const _hoisted_28 = {
  key: 0,
  class: "pt-2 text-center"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white font-weight-bold" }, "Sell With Moonpay", -1))

import {
  computed,
  reactive,
  watch,
  onMounted,
  ref,
  Ref,
  inject,
} from "vue";
import { currencySymbols } from "./handler/prices";
import { debounce, isNumber } from "lodash";
import { sha3 } from "web3-utils";
import MewAddressSelect from "../MewAddressSelect/MewAddressSelect.vue";
import { Network } from "./network/types";

import { storeToRefs } from "pinia";
import { useGlobalStore } from "@/plugins/globalStore";
import addressValidator from "@/helpers/addressValidator";
import api from "./handler/api";
import BigNumber from "bignumber.js";

const defaultFiatValue = "300";

export default /*#__PURE__*/_defineComponent({
  __name: 'SellForm',
  props: {
  heldAddress: {
    type: String,
    default: "",
  },
},
  emits: ["addressInput"],
  setup(__props, { emit: __emit }) {

const amplitude: any = inject("$amplitude");

const props = __props;

const emit = __emit;

const store = useGlobalStore();
const { setSelectedCrypto } = store;
const {
  selectedFiat,
  selectedCrypto,
  selectedNetwork,
  sellFiats,
  sellNetworks,
  cgPrice,
} = storeToRefs(store);

const { setSelectedNetwork, toggleTokenModal, setSelectedFiat } = store;

const rules = [
  (e: any) => {
    if (!isNumber(Number(e))) return "Must be a valid number";
    if (BigNumber(e).lte(0)) return "Must be greater than 0";
    if (BigNumber(e).isNaN()) return "Must be a valid number";
    return true;
  },
];
const fiatRules = [
  (e: any) => {
    if (!isNumber(Number(e))) return "Must be a valid number";
    if (BigNumber(e).lte(0)) return "Must be greater than 0";
    if (BigNumber(e).isNaN()) return "Must be a valid number";
    if (BigNumber(e).gt(max.value))
      return `Maximum amount is ${max.value} ${selectedFiat.value.name}`;
    if (BigNumber(e).lt(min.value))
      return `Minimum amount is ${min.value} ${selectedFiat.value.name}`;
    return true;
  },
];

// reactive
const fiatFilter = ref("");
const fiatItems: Ref<string[]> = ref(Array.from(sellFiats.value.keys()));
const filteredFiatItems: Ref<string[]> = ref(
  Array.from(sellFiats.value.keys())
);
const updateFiatFilter = (filter: string) => {
  fiatFilter.value = filter;
  if (filter) {
    filteredFiatItems.value = fiatItems.value.filter((item) =>
      item.toLowerCase().includes(fiatFilter.value.toLowerCase())
    );
  } else {
    filteredFiatItems.value = fiatItems.value;
  }
};

const fiatForm = ref(null);

// reactive
const form = reactive({
  fiatAmount: defaultFiatValue,
  fiatSelected: "USD",
  cryptoAmount: "1",
  cryptoSelected: "ETH",
  address: "",
  validAddress: false,
  addressErrorMsg: "",
  addressError: false,
  fees: "",
  quoteError: "",
  balance: "",
  balanceWei: "",
  balanceETH: "",
  balanceError: false,
  balanceErrorMsg: "",
  url: "",
  fiatAmountError: "",
});
const loading = reactive({
  data: false,
  showAlert: false,
  processingBuyForm: false,
  alertMessage: "",
});

const addressSelect = ref(null);

onMounted(async () => {
  form.address = "";

  if (addressSelect.value) {
    addressSelect.value.locAddress = props.heldAddress;
    addressSelect.value.onInputChange(props.heldAddress);
  }

  // check if current selected network is supported in sell networks
  const network = sellNetworks.value.find(
    (n: Network) => n.name === selectedNetwork.value.name
  );

  if (!network) {
    setSelectedNetwork(sellNetworks.value[0]);
  } else {
    setSelectedNetwork(network);
  }

  // check if current selected fiat is supported in sell fiats
  const fiat = sellFiats.value.get(selectedFiat.value.name);
  const crypto = selectedNetwork.value.tokens.find(
    (token) => token.symbol === selectedCrypto.value.symbol
  );

  if (!crypto) {
    form.cryptoSelected = selectedCrypto.value.symbol;
    setSelectedCrypto(selectedNetwork.value.tokens[0]);
  } else {
    form.cryptoSelected = crypto.symbol;
  }

  if (!fiat) {
    const locFiat = sellFiats.value.get("USD");
    setSelectedFiat(
      locFiat
        ? {
            name: locFiat.fiat_currency,
            value: locFiat.fiat_currency,
            img: locFiat.img,
          }
        : {
            name: "USD",
            value: "USD",
            img: require("@/assets/images/fiat/USD.svg"),
          }
    );
    form.fiatSelected = "USD";
  } else {
    form.fiatSelected = selectedFiat.value.name;
  }
  quoteFetch(form.address).then(() => fiatToCrypto());
});

// computed
const validFiatAmount = computed(() => {
  if (!isNumber(Number(form.fiatAmount))) return false;
  if (BigNumber(form.fiatAmount).lte(0)) return false;
  if (BigNumber(form.fiatAmount).isNaN()) return false;
  if (BigNumber(form.fiatAmount).gt(max.value)) return false;
  if (BigNumber(form.fiatAmount).lt(min.value)) return false;
  return true;
});

const validCryptoAmount = computed(() => {
  if (!isNumber(Number(form.cryptoAmount))) return false;
  if (BigNumber(form.cryptoAmount).lte(0)) return false;
  if (BigNumber(form.cryptoAmount).isNaN()) return false;
  return true;
});
const formattedFiatFee = computed(() => {
  const amount = form.fees;
  const symbol = currencySymbols[selectedFiat.value.name]
    ? currencySymbols[selectedFiat.value.name]
    : "";
  return `${symbol}${amount} ${selectedFiat.value.name}`;
});

const isValidForm = computed(() => {
  return (
    form.fiatSelected &&
    form.cryptoSelected &&
    form.address &&
    !form.addressError &&
    form.addressErrorMsg === "" &&
    form.quoteError === "" &&
    loading.alertMessage === "" &&
    form.validAddress &&
    !loading.data &&
    validFiatAmount.value &&
    validCryptoAmount.value
  );
});

const cryptoPrice = computed(() => {
  if (selectedCrypto.value.price) return selectedCrypto.value.price;
  const foundToken = selectedNetwork.value.tokens.find((token) => {
    if (token.symbol === selectedCrypto.value.symbol) {
      return token;
    }
  });
  if (!foundToken) return 100;
  if (foundToken.price) return foundToken.price;
  if (foundToken.cgId) {
    const price = cgPrice.value.get(foundToken.cgId);
    if (price) return price;
  }
  return 100;
});

const min = computed(() => {
  const fiat = sellFiats.value.get(selectedFiat.value.name);
  return fiat ? fiat.limits.min : 50;
});

const max = computed(() => {
  const fiat = sellFiats.value.get(selectedFiat.value.name);
  return fiat ? fiat.limits.max : 20000;
});

// watchers
watch(
  () => selectedFiat.value,
  () => {
    if (fiatForm.value) {
      fiatForm?.value.validate().then(() => {
        cryptoToAmount();
      });
    }
  },
  { deep: true }
);
watch(
  () => form.address,
  (formAddress) => {
    form.validAddress = false;
    form.addressError = false;
    form.addressErrorMsg = "";
    if (formAddress) {
      verifyAddress();
      quoteFetch(form.address);
    }
  },
  { deep: true }
);

// methods
const fiatToCrypto = debounce(() => {
  if (form.fiatAmount && isNumber(Number(form.fiatAmount))) {
    form.cryptoAmount = BigNumber(form.fiatAmount)
      .div(cryptoPrice.value)
      .toString();
    // const generated = isObject(onlyGenerate) ? false : onlyGenerate;
    if (form.cryptoAmount) {
      quoteFetch(form.address);
    }
  }
}, 500);
const cryptoToAmount = debounce(() => {
  if (form.cryptoAmount && isNumber(Number(form.cryptoAmount))) {
    form.fiatAmount = BigNumber(form.cryptoAmount)
      .times(cryptoPrice.value)
      .toString();
    if (form.fiatAmount) {
      quoteFetch(form.address);
    }
  }
}, 500);

const verifyAddress = async () => {
  const valid = addressValidator(form.address, form.cryptoSelected);
  if (valid) {
    const { isRestricted } = await fetch(
      `https://partners.mewapi.io/o/walletscreen?address=${form.address}`
    ).then((res) => res.json());
    if (isRestricted) {
      form.addressErrorMsg = `Please provide a valid ${form.cryptoSelected} address`;
      form.addressError = true;
      form.validAddress = false;
      return;
    }

    form.addressErrorMsg = "";
    form.addressError = false;
    form.validAddress = true;
  } else {
    if (!form.address) {
      form.addressErrorMsg = "";
      form.validAddress = false;
    } else {
      form.addressErrorMsg = `Please provide a valid ${form.cryptoSelected} `;
      form.validAddress = false;
    }
  }
};

const openTokenSelect = () => {
  toggleTokenModal();
};

const quoteFetch = async (address: string): Promise<void> => {
  form.quoteError = "";
  const defaultAddress: { [key: string]: string } = {
    ADA: "addr1vx7j284mqe59w2mka36gf5xq0hvu8ms2989553fk5qh3prcapfpj3",
    ALGO: "4H5UNRBJ2Q6JENAXQ6HNTGKLKINP4J4VTQBEPK5F3I6RDICMZBPGNH6KD4",
    ARB: "0xDECAF9CD2367cdbb726E904cD6397eDFcAe6068D",
    ATOM: "cosmos10taaryv2hhjwxlztes38sqxfce6q090a2m2sss",
    BASE: "0xDECAF9CD2367cdbb726E904cD6397eDFcAe6068D",
    BCH: "bitcoincash:qzrzqwm4tllqevxplgcz4qdcrt837r7wyg0k5l2gwq",
    BSC: "0xDECAF9CD2367cdbb726E904cD6397eDFcAe6068D",
    BTC: "1DECAF2uSpFTP4L1fAHR8GCLrPqdwdLse9",
    DOGE: "DCGqu6EtF5m83NYgSWPQiGM3mDuxn8Hgtm",
    ETH: "0xDECAF9CD2367cdbb726E904cD6397eDFcAe6068D",
    LTC: "LcNS6c8RddAMjewDrUAAi8BzecKoosnkN3",
    OP: "0xDECAF9CD2367cdbb726E904cD6397eDFcAe6068D",
    POL: "0xDECAF9CD2367cdbb726E904cD6397eDFcAe6068D",
    SOL: "7ngWv14ECRwq8QNQJCaYGCL7wppJYrh4UUgSTCZQeaca",
    XLM: "GCJ2RDQLOVNOYBD2LELEGEVIDZ3LRLPHGANVOFJZXTUQHKHVZX2LMRFB",
  };
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const platform = urlParams.get("platform") || "web";
  const userAddress = address
    ? address
    : defaultAddress[selectedNetwork.value.name]; // mew donation to enable fetch before user adds address
  const data = await fetch(
    `${api.endpoint}/v5/purchase/sell?id=${sha3(userAddress)?.substring(
      0,
      42
    )}&address=${userAddress}&fiatCurrency=${selectedFiat.value.name}&amount=${
      form.cryptoAmount
    }&cryptoCurrency=${selectedCrypto.value.symbol}&chain=${
      selectedNetwork.value.name
    }&platform=${platform}`
  );
  const quote = await data.json();
  const { msg, errors, error } = quote;
  if (msg || error) {
    let message = "";
    if (errors) {
      errors.forEach((error: any) => {
        message += `${error} `;
      });

      form.quoteError = `${msg}. ${message}`;
      return;
    }
    form.quoteError = msg;
    return;
  }
  form.fees = quote[0].fiat_fees;
  if (address) form.url = quote[0].url; // only set url if address is provided
};

// methods
const getIcon = (currency: string, isFiat = true) => {
  return require(`@/assets/images/${
    isFiat ? "fiat" : "crypto"
  }/${currency}.svg`);
};

const selectCurrency = (currency: string) => {
  form.fiatSelected = currency;
  setSelectedFiat({
    name: currency,
    value: currency,
    img: require(`@/assets/images/fiat/${currency}.svg`),
  });
};

const addressInput = (value: string, isResolved: string): void => {
  form.address = value;
  emit("addressInput", isResolved ? isResolved : value);
  verifyAddress();
};

const submitForm = async (): Promise<void> => {
  loading.processingBuyForm = true;
  amplitude.track("CCBuySellSellWithMoonpay");
  window.open(form.url, "_blank");
  loading.processingBuyForm = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!loading.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_text_field, {
          type: "number",
          modelValue: form.cryptoAmount,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.cryptoAmount) = $event)),
          required: "",
          variant: "outlined",
          rounded: "left",
          "hide-details": "auto",
          rules: rules,
          disabled: loading.data,
          error: form.balanceError,
          class: "no-right-border",
          onInput: _unref(cryptoToAmount)
        }, null, 8, ["modelValue", "disabled", "error", "onInput"]),
        _createVNode(_component_v_btn, {
          modelValue: form.cryptoSelected,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.cryptoSelected) = $event)),
          rounded: "right",
          variant: "outlined",
          class: "no-left-border custom-btn",
          onClick: openTokenSelect,
          "append-icon": "mdi-menu-down",
          style: {"max-width":"130px"},
          disabled: loading.data
        }, {
          prepend: _withCtx(() => [
            _createElementVNode("img", {
              class: "currency-icon mr-1 padding--2",
              src: _unref(selectedCrypto).img,
              alt: form.cryptoSelected,
              width: "25px",
              height: "25px"
            }, null, 8, _hoisted_7)
          ]),
          append: _withCtx(() => [
            _createVNode(_component_v_icon, {
              color: "grey-2",
              size: "large"
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(form.cryptoSelected), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_8, "Network: " + _toDisplayString(_unref(selectedNetwork).name_long), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_v_text_field, {
          type: "number",
          modelValue: form.fiatAmount,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.fiatAmount) = $event)),
          required: "",
          variant: "outlined",
          rounded: "left",
          rules: fiatRules,
          "error-messages": loading.alertMessage,
          disabled: loading.data,
          class: "no-right-border",
          onInput: _unref(fiatToCrypto)
        }, null, 8, ["modelValue", "error-messages", "disabled", "onInput"]),
        _createVNode(_component_v_select, {
          style: {"max-width":"130px"},
          class: "rounded-right no-left-border",
          modelValue: form.fiatSelected,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.fiatSelected) = $event)),
          items: filteredFiatItems.value,
          disabled: loading.data,
          "menu-props": { closeOnContentClick: true },
          "base-color": "primary",
          "return-object": "",
          variant: "outlined"
        }, {
          "prepend-inner": _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: _unref(selectedFiat).img,
                alt: form.fiatSelected,
                width: "30px",
                height: "30px"
              }, null, 8, _hoisted_13)
            ])
          ]),
          "prepend-item": _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: fiatFilter.value,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((fiatFilter).value = $event)),
                updateFiatFilter
              ],
              ref_key: "fiatForm",
              ref: fiatForm,
              variant: "outlined",
              class: "px-2",
              "prepend-inner-icon": "mdi-magnify",
              density: "compact",
              placeholder: "Search",
              autofocus: true,
              "error-messages": form.fiatAmountError,
              onClick: _cache[4] || (_cache[4] = _withModifiers((e) => e.preventDefault(), ["stop"]))
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          item: _withCtx((data) => [
            _createElementVNode("div", {
              class: "d-flex align-center justify-space-between full-width cursor-pointer",
              onClick: ($event: any) => (selectCurrency(data.item.value))
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("img", {
                    src: getIcon(data.item.value),
                    alt: data.item.value,
                    width: "30px",
                    height: "30px"
                  }, null, 8, _hoisted_17)
                ]),
                _createElementVNode("span", _hoisted_18, _toDisplayString(data.item.value), 1)
              ])
            ], 8, _hoisted_14)
          ]),
          _: 1
        }, 8, ["modelValue", "items", "disabled"])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_19,
      _createVNode(MewAddressSelect, {
        ref_key: "addressSelect",
        ref: addressSelect,
        "model-value": form.address,
        "error-messages": form.addressErrorMsg,
        autofocus: false,
        label: "",
        "is-valid-address": form.validAddress,
        placeholder: "Enter Crypto Address",
        network: _unref(selectedNetwork),
        onKeyup: verifyAddress,
        onChanged: addressInput
      }, null, 8, ["model-value", "error-messages", "is-valid-address", "network"])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createTextVNode(" After submitting your sell order, you will have to send your crypto to MoonPay. Make sure to have enough currency in your wallet to cover network transaction fees. "),
      _hoisted_21,
      _hoisted_22,
      (form.fees)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("span", _hoisted_25, _toDisplayString(formattedFiatFee.value), 1)
          ]))
        : _createCommentVNode("", true),
      (form.quoteError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, _toDisplayString(form.quoteError), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!loading.processingBuyForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", null, [
            _createVNode(_component_v_btn, {
              flat: "",
              rounded: "pill",
              disabled: !isValidForm.value,
              "min-height": "60px",
              width: "360px",
              onClick: submitForm,
              class: "sell-button"
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})